import React from "react";

/**
 * Cole aqui o HTML original do <body>…</body> do seu index.html (do ZIP).
 * NÃO inclua <html>, <head> ou <body>.
 */
const RAW_HTML = `
<!-- EXEMPLO de placeholder:
<section id="legacy-root">
  <!-- Cole aqui o conteúdo real do seu <body> -->
  <!-- Quando colar, tudo fica 100% igual ao HTML original -->
</section>
`;

export default function LegacyLandingSection() {
  return <div dangerouslySetInnerHTML={{ __html: RAW_HTML }} />;
}
